import api from './api';

const updateFetalById = async payload => {
  const { data } = await api.put(`/fetal/${payload.CODFETAL}`, payload);
  return data;
};

const selectFetalById = async payload => {
  const { data } = await api.get(`fetal/${payload}`);
  return data[0];
};

export { updateFetalById, selectFetalById };
